<app-checkin-shell
    [canNext]="canNext"
    [isLastStep]="isLastStep"
    (back)="prev()"
    (forward)="next()"
    (home)="goHome()"
    (save)="save()">

    <!-- STEP 1 : Type de livraison + Destinataire -->
    @if (currentStep() === 1) {
    <div class="flex flex-col space-y-6">
        <p class="text-blue-600 text-lg">{{ 'vues.ipad.checkin.fillfields' | translate }}</p>

        <div class="flex flex-col space-y-3">
            <label class="flex items-center gap-3 cursor-pointer">
                <input type="radio" name="deliveryType"
                    [checked]="selectedDeliveryType() === 1"
                    (change)="selectedDeliveryType.set(1)"
                    class="w-5 h-5 accent-teal-600">
                <span class="text-lg text-gray-800">{{ 'entities.delivery.propreties.deliveryTypeParcel' | translate }}</span>
            </label>
            <label class="flex items-center gap-3 cursor-pointer">
                <input type="radio" name="deliveryType"
                    [checked]="selectedDeliveryType() === 2"
                    (change)="selectedDeliveryType.set(2)"
                    class="w-5 h-5 accent-teal-600">
                <span class="text-lg text-gray-800">{{ 'entities.delivery.propreties.deliveryTypeMeal' | translate }}</span>
            </label>
        </div>

        <app-multi-select
            [options]="employeeLookup()"
            [isMultiselect]="false"
            [minChars]="2"
            [skin]="Skin"
            [placeholder]="'vues.ipad.checkin.recipient-search'"
            [maxItems]="1"
            [selectedKeys]="selectedEmployeeKeys()"
            (selectedKeysChange)="onEmployeeSelectChange($event)">
        </app-multi-select>
    </div>
    }

    <!-- STEP 2 : Photo du colis -->
    @if (currentStep() === 2) {
    <div class="flex flex-col items-center space-y-4">
        <app-photo-capture
            [showSilhouette]="false"
            [instructionsKey]="'vues.ipad.checkin.photo.instructions-package'"
            (photoFile)="onPhotoFile($event)">
        </app-photo-capture>
        @if (imageFile()) {
        <div class="text-center text-green-600">
            <i class="fas fa-check-circle text-2xl"></i>
            <p class="mt-1 text-sm">{{ 'Photo captured' | translate }}</p>
        </div>
        }
    </div>
    }

</app-checkin-shell>
